import { FormikProps } from "formik";
import CustomInput from "../../../components/common/Inputs/CustomInput";
import SelectInput, {
  OptionType,
} from "../../../components/common/Inputs/SelectInput";
import Checkbox from "../../../components/common/Inputs/Checkbox";
import { ProductInterface } from "../../../interfaces/productInterface";

type ProductFormProps = {
  formik: FormikProps<ProductInterface>;
  categoriesOptions: OptionType[];
};

export const ProductForm = (props: ProductFormProps) => {
  const { formik, categoriesOptions } = props;

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
      <CustomInput
        label="Producto"
        error={
          formik.touched.name &&
          formik.errors.name &&
          Array.isArray(formik.errors.name)
            ? formik.errors.name.join(", ")
            : formik.errors.name
        }
        {...formik.getFieldProps("name")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <SelectInput
        label="Categoría"
        options={categoriesOptions}
        error={
          formik.touched.categoryId &&
          formik.errors.categoryId &&
          Array.isArray(formik.errors.categoryId)
            ? formik.errors.categoryId.join(", ")
            : formik.errors.categoryId
        }
        {...formik.getFieldProps("categoryId")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Precio"
        type="number"
        error={
          formik.touched.price &&
          formik.errors.price &&
          Array.isArray(formik.errors.price)
            ? formik.errors.price.join(", ")
            : formik.errors.price
        }
        {...formik.getFieldProps("price")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Costo"
        type="number"
        error={
          formik.touched.cost &&
          formik.errors.cost &&
          Array.isArray(formik.errors.cost)
            ? formik.errors.cost.join(", ")
            : formik.errors.cost
        }
        {...formik.getFieldProps("cost")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="Código de barras"
        error={
          formik.touched.barCode &&
          formik.errors.barCode &&
          Array.isArray(formik.errors.barCode)
            ? formik.errors.barCode.join(", ")
            : formik.errors.barCode
        }
        {...formik.getFieldProps("barCode")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <CustomInput
        label="SKU"
        error={
          formik.touched.sku &&
          formik.errors.sku &&
          Array.isArray(formik.errors.sku)
            ? formik.errors.sku.join(", ")
            : formik.errors.sku
        }
        {...formik.getFieldProps("sku")}
        onChange={(e) => {
          formik.handleChange(e);
        }}
      />
      <Checkbox
        label="es granel?"
        id={"isBulk"}
        name="isBulk"
        onChange={() => {
          formik.setFieldValue("isBulk", !formik.values.isBulk);
        }}
        checked={formik.values.isBulk}
      />
    </div>
  );
};
